import './BubbleOverlay.scss';

import React from 'react';
import { BubbleLoader } from '.';
import { BubbleLoaderProps } from './BubbleLoader';

export interface BubbleOverlayPropsBase {
  loading?: boolean;
  opacity?: number;
  hideSpinner?: boolean;
  hideBg?: boolean;
  loaderProps?: BubbleLoaderProps;
  loadingClassName?: string;
  loadingMinHeight?: 'small' | 'medium' | 'large';
  loadingStyle?: React.CSSProperties;
  replaceIcon?: () => React.ReactNode;
}

export type BubbleOverlayProps = React.HTMLAttributes<HTMLDivElement> & BubbleOverlayPropsBase;

export default function BubbleOverlay(props: BubbleOverlayProps) {
  const {
    // from component
    loading,
    opacity,
    hideSpinner,
    hideBg,
    loaderProps,
    loadingClassName: propLoadingClassName,
    loadingStyle: propLoadingStyle,
    loadingMinHeight,
    replaceIcon,
    // from element
    className: propClassName,
    style: propStyle,
    children,
    ...rest
  } = props;

  const classes = ['bubble-overlay'];
  if (propClassName) classes.push(propClassName);

  let style: React.CSSProperties = {};
  if (propStyle) style = { ...style, ...propStyle };

  const loadingClasses = ['bubble-loading'];
  if (propLoadingClassName) loadingClasses.push(propLoadingClassName);

  let loadingStyle: React.CSSProperties = {};
  if (loadingMinHeight) {
    loadingStyle = {
      ...loadingStyle,
      minHeight:
        loadingMinHeight === 'small'
          ? '50px'
          : loadingMinHeight === 'medium'
            ? '200px'
            : loadingMinHeight === 'large'
              ? '500px'
              : '',
    };
  }
  if (!hideBg) loadingStyle.backgroundColor = `rgba(255, 255, 255, ${opacity || 0.7})`;
  if (propLoadingStyle) loadingStyle = { ...loadingStyle, ...propLoadingStyle };

  return (
    <div {...rest} className={classes.join(' ')} style={style}>
      {children}
      {loading && (
        <div className={loadingClasses.join(' ')} style={loadingStyle}>
          {!hideSpinner && <>{!replaceIcon ? <BubbleLoader {...loaderProps} /> : replaceIcon()}</>}
        </div>
      )}
    </div>
  );
}
